import React from 'react'
import { Form, Input, Button, Row, Col, Checkbox } from 'antd'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import PropTypes from 'prop-types'
import { autobind } from 'core-decorators'
import createLanguageHoc, { langPropTypes } from 'hoc/create-lang'
import { mapPropsToFields } from 'utils/form'
import InputNumberCell from 'components/elements/input-number-cell'

const { TextArea } = Input

const FormItem = Form.Item
@Form.create({
  mapPropsToFields: mapPropsToFields
})
@createLanguageHoc
@autobind
export default class QAForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func,
    lang: langPropTypes,
    isEdit: PropTypes.bool,
    initialValues: PropTypes.object
  }

  constructor(props) {
    super(props)
    let editorState = null

    if (this.props.initialValues && this.props.initialValues.content) {
      const contentBlock = htmlToDraft(this.props.initialValues.content)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        editorState = EditorState.createWithContent(contentState)
      }
    }

    this.state = {
      editorState
    }
  }

  async handleSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (err) return
      // var convertedData = convertToRaw(values.content);
      var contentHTML = draftToHtml(values.content)
      const data = {
        title: values.title,
        content: contentHTML,
        summary: values.summary,
        numericalOrder: values.numericalOrder,
        isPublish: values.isPublish
      }
      // Callback submit form Container Component
      console.log(data)
      await this.props.onSubmit(data)
    })
  }

  handleEditorChange = editorState => {
    this.setState({
      editorState
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 12 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 16 }
      }
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={8}>
          <Col span={24}>
            <FormItem {...formItemLayout} label="Tiêu đề">
              {getFieldDecorator('title', {
                rules: [
                  {
                    required: true,
                    message: 'Chưa nhập tiêu đề'
                  }
                ]
              })(<Input />)}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={24}>
            <FormItem {...formItemLayout} label="Tóm tắt nội dung">
              {getFieldDecorator('summary', {
                rules: [
                  {
                    required: true,
                    message: 'Chưa nhập nội dung tóm tắt'
                  }
                ]
              })(<TextArea autosize={{ minRows: 2, maxRows: 4 }} />)}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={24}>
            <FormItem {...formItemLayout} label="Nội dung">
              {getFieldDecorator('content', {
                rules: [
                  {
                    required: true,
                    message: 'Chưa nhập nội dung'
                  }
                ]
              })(
                <Editor
                  editorState={this.state.editorState}
                  onEditorStateChange={this.handleEditorChange}
                  wrapperClassName="wrapper-class"
                  editorClassName="editor-class"
                  toolbarClassName="toolbar-class"
                  editorStyle={{
                    border: '1px solid #f4f4f4',
                    minHeight: 500,
                    width: '100%'
                  }}
                />
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={6} offset={4}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('isPublish', {
                valuePropName: 'checked',
                rules: [{ required: true }]
              })(<Checkbox>{'Is Publish'}</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={14}>
            <FormItem {...formItemLayout} label="Number Order">
              {getFieldDecorator('numericalOrder', {
                rules: [{ required: true }]
              })(<InputNumberCell editable={true} size="small" min={1} max={1000000} />)}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={20} offset={4}>
            <FormItem label="" {...formItemLayout}>
              <Button style={{ width: 200 }} type="primary" htmlType="submit">
                {'Send request'}
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/qa/form/index.js